module.exports = __webpack_public_path__ + "static/media/lien_holder.613e28c4.svg";